/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { Folder } from "../../assets";
import { locales } from "../../locales";
import CandidatesAccordion from "./CandidatesAccordion";

const CandidatesContainer = ({
  data,
  index,
  langId,
  isDesktop,
  lastUpdateDate,
  handleShowTooltip,
  handleHideTooltip,
}) => {
  const [isAllOpened, setIsAllOpened] = useState(false);
  const hasCandidatesInParties = () => {
    let result = false;
    data.parties.forEach((party) => {
      if (party.candidates.length > 0) {
        result = true;
      }
    });
    return result;
  };
  const hasCandidates =
    data.parties && data.parties.length > 0 && hasCandidatesInParties();

  const hasOnlyOneParty =
    data.parties.filter((party) => party.candidates.length > 0).length <= 1;
  const setAllOpenedHandler = () => {
    // console.log("isAllOpened", isAllOpened);
    setIsAllOpened(!isAllOpened);
    window.wort.frameResize();
  };

  const isCommuneTypeList = data.type === locales[langId].communeTypeList;
  const hasLastUpdate = data.lastUpdate && data.lastUpdate !== null;

  const showAllStyle = (isDesktop) => {
    if (isDesktop) {
      return { color: "#0080B7", fontSize: 17, lineHeight: "21px" };
    } else {
      return { color: "#0080B7", fontSize: 14, lineHeight: "17px" };
    }
  };

  useEffect(() => {
    if (!isAllOpened && hasOnlyOneParty) {
      setAllOpenedHandler();
    }
  }, [isAllOpened]);

  return (
    <div key={index} className="mb-14">
      <div className="flex flex-row border-2 border-gray-200 border-t-0 border-l-0 border-r-0 pb-2">
        <div className="flex flex-col w-8/12 md:items-baseline wort-medium:flex-row items-baseline">
          <span className="font-semibold text-32 leading-38">
            {locales[langId].candidatesForTheCommune}
          </span>
          {!isDesktop && (
            <div>
              {hasLastUpdate && (
                <span
                  className="text-xs"
                  style={{ color: "rgba(0, 0, 0, 0.6)", marginLeft: "10px" }}
                >
                  {locales[langId].update}: {data.lastUpdate}
                </span>
              )}
            </div>
          )}
        </div>
        {hasCandidates && (
          <div className="pt-3 text-right w-4/12">
            {isDesktop && hasLastUpdate && (
              <span
                className="mr-10 text-xs"
                style={{ color: "rgba(0, 0, 0, 0.6)" }}
              >
                {locales[langId].update}: {data.lastUpdate}
              </span>
            )}
            <span
              className="font-bold cursor-pointer"
              style={showAllStyle(isDesktop)}
              onClick={setAllOpenedHandler}
            >
              {!isAllOpened ? locales[langId].seeAll : locales[langId].closeAll}
            </span>
          </div>
        )}
      </div>
      <dl className="space-y-0 divide-y divide-gray-200 wort-medium:px-5">
        {hasCandidates &&
          data.parties
            .sort((a, b) => a.listNumber - b.listNumber)
            .map((item) => {
              if (item.candidates.length > 0) {
                return (
                  <CandidatesAccordion
                    key={item.id}
                    data={item}
                    langId={langId}
                    isDesktop={isDesktop}
                    openCloseAll={isAllOpened}
                    commune={data.commune}
                    communeType={data.type}
                    onShowTooltip={handleShowTooltip}
                    onHideTooltip={handleHideTooltip}
                  />
                );
              }
            })}
        {!hasCandidates && (
          <div
            className="flex flex-row justify-center mt-3 border-dashed border-2 border-gray-300 pt-5 pl-5 bg-wort-background"
            style={{ height: 89 }}
          >
            <Folder />
            <span
              className="ml-5"
              style={{ fontSize: "22px", lineHeight: "26.4px" }}
            >
              {isCommuneTypeList
                ? locales[langId].noDataList
                : locales[langId].noDataSmall}
            </span>
          </div>
        )}
      </dl>
    </div>
  );
};

export default CandidatesContainer;
